import { Box, Button, Icon,  } from "@shopify/polaris";
import React from "react";
import {
  CancelMajor
} from '@shopify/polaris-icons';
import "./index.css";
import utils from '../../utils/utils';
import { withRouter } from "react-router-dom";
import { useHistory } from 'react-router-dom/cjs/react-router-dom';
const Index = ({level,handleOffFourthBanner}) => {
  const history = useHistory();
  return (
      <Box>
        <Box className="fourth_banner" style={{backgroundImage:'url(/sub/dashbord_top_fourth_banner.png)'}}>
          <img src="/sub/big_gift.png" alt="Dropshipman" />
          <p><span>Dropshipman 4th Anniversary:</span> <span> {Number(level) === 0 ? <strong>40%</strong>:<strong>$40</strong>} {Number(level) === 0 ? "Off All Packages!" : 'Coupons for everyone'}</span></p>
          <Button onClick={()=>{
                    if (Number(level) === 0) {
                        utils.routeListen('/admin/subscribe')
                        utils.routeJump1(history,'/admin/subscribe')
                    }else {
                        utils.routeListen('/admin/coupon')
                        utils.routeJump1(history,'/admin/coupon')
                    }
                }}>Claim the {Number(level) === 0 ? 'discount' : 'coupons'}</Button>
          <span className="fourth_banner_off" onClick={()=>{handleOffFourthBanner()}}>
          <Icon
            source={CancelMajor}
            tone="base"
          />
          </span>
        </Box>
      </Box>
  );
};

export default withRouter(Index);
